import { Link, NavLink } from "react-router-dom";
import ArrowForwardTwoToneIcon from "@mui/icons-material/ArrowForwardTwoTone";
import { SvgIconTypeMap } from "@mui/material";
import { OverridableComponent } from "@mui/material/OverridableComponent";
import VrpanoTwoToneIcon from "@mui/icons-material/VrpanoTwoTone";
import BusinessTwoToneIcon from "@mui/icons-material/BusinessTwoTone";
import PeopleAltTwoToneIcon from "@mui/icons-material/PeopleAltTwoTone";
import OndemandVideoTwoToneIcon from "@mui/icons-material/OndemandVideoTwoTone";
import VideoGameAssetIcon from "@mui/icons-material/VideogameAsset";
import LiveTvIcon from '@mui/icons-material/LiveTv';
import PageTitle from "../../components/PageTitle";
import AddAlertIcon from '@mui/icons-material/AddAlert';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import NewspaperIcon from '@mui/icons-material/Newspaper';
import CampaignIcon from '@mui/icons-material/Campaign';

interface LinkCardProps {
  to: string;
  title: string;
  description: string;
  icon: OverridableComponent<SvgIconTypeMap<{}, "svg">>;
}

function LinkCard({ to, title, description, icon: Icon }: LinkCardProps) {
  return (
    <NavLink to={to} className="card p-4 flex flex-row gap-4">
      <div className="flex items-center h-full">
        <Icon />
      </div>
      <div className="flex flex-col gap-2 grow">
        <h2 className="text-lg xl:text-2xl">{title}</h2>
        <p>{description}</p>
      </div>
      <div className="flex items-center h-full">
        <ArrowForwardTwoToneIcon />
      </div>
    </NavLink>
  );
}

export default function AdminHomePage() {
  return (
    <div className="flex flex-col gap-4">
      <PageTitle>Administrator</PageTitle>
      <div className="grid grid-cols-1 lg:grid-cols-2 2xl:grid-cols-4 gap-4">
        <LinkCard
          to="/admin/live"
          title="Live now"
          description="Live streamers"
          icon={LiveTvIcon} />
        <LinkCard
          to="/admin/campaigns"
          title="Campaigns"
          description="Manage live app campaigns"
          icon={CampaignIcon} />
          <LinkCard
          to="/admin/adverts"
          title="Adverts"
          description="Manage live app adverts"
          icon={CampaignIcon} />
        <LinkCard
          to="/admin/experiences"
          title="Experiences"
          description="Manage experiences"
          icon={VrpanoTwoToneIcon}
        />
        <LinkCard
          to="/admin/companies"
          title="Organisations"
          description="Manage organisations"
          icon={BusinessTwoToneIcon}
        />
        <LinkCard
          to="/admin/users"
          title="Users"
          description="Manage users"
          icon={PeopleAltTwoToneIcon}
        />
        <LinkCard
          to="/admin/titles"
          title="Titles"
          description="Manage titles"
          icon={VideoGameAssetIcon}
        />
        <LinkCard
          to="/admin/sessions/sdk"
          title="Sessions"
          description="View sessions"
          icon={LiveTvIcon}
        />
        <LinkCard
          to="/admin/videos"
          title="Videos"
          description="Manage videos"
          icon={OndemandVideoTwoToneIcon}
        />
        <LinkCard
          to="/admin/status"
          title="Status messages"
          description="Set status messages"
          icon={AddAlertIcon} />
        <LinkCard
          to="/admin/featurepromotions"
          title="Feature promotions"
          description="Make paid features free for a set window, and switch app features on"
          icon={LocalOfferIcon} />
        <LinkCard
          to="/admin/articles"
          title="Articles"
          description="Manage news articles"
          icon={NewspaperIcon} />
      </div>
    </div>
  );
}
